<template lang="pug">
#users
  .md-layout
    .md-layout-item.ml-auto
      md-button.md-warning(
        style='float: right;'
        @click='handleNewUser')
        v-icon(style='color: black !important; padding-right: 4px;') mdi-plus
        span(style='color: black')
          | {{$t('managementAccess.create')}}
  div
    DataProvider(:endpoint='mountUrlAndParams("users").url' :filter='filter' ref='dataProvider')
      div(slot-scope='{ data: response, error, loading }')
        DataTable(
          customIcon='user-config-circle'
          :buttonHeaders='false'
          :data='response && response.hits'
          ref='dataTable'
          :title="$t('drawer.users.subitems.usersList')"
          :customTotal='(response && response.total) || 0'
          @pagination='handlePagination'
          :currentSort.sync='filter.orderBy',
          :currentSortOrder.sync='filter.order',
          :selectable='false'
          :loading='loading'
          customHeader
          showPagination
          :endpoint='mountUrlAndParams("users").url'
          :filter='filter'
          :labels='labels'
          :formatLabelFunction='formatLabels'
          :fileName="$t('campaign.campaignListFileName')"
          orientationPDF="landscape"
          :createHeader='createHeaderPDF'
        )
          template(slot='footer' slot-scope='{ pagination }')
            v-row(style='justify-content: flex-end;')
              v-col(cols='auto')
                md-field
                  label(for='pages') {{ $t('assistantsList.perPage') }}
                  md-select(v-model='pagination.perPage' name='pages' )
                    md-option(
                      v-for='item in pagination.perPageOptions',
                      :key='item',
                      :label='item',
                      :value='item')
                      | {{ item }}
          template(slot='cells' slot-scope='{ item }')
            md-table-cell(:md-label='labels[0]') {{ formatLabels(item, 0) }}
            md-table-cell(:md-label='labels[1]') {{ formatLabels(item, 1) }}
            md-table-cell(:md-label='labels[2]') {{ formatLabels(item, 2) }}
            md-table-cell(:md-label='labels[3]') {{ formatLabels(item, 3) }}
            md-table-cell(:md-label='labels[4]') {{ formatLabels(item, 4) }}
            md-table-cell(:md-label='$t("managementAccess.actions")')
              v-row(no-gutters style='justify-content: flex-start;')
                v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                  v-btn(
                    class="mx-2"
                    x-small
                    fab
                    dark
                    color="#20A6E5"
                    @click='handleShowUser(item)'
                  )
                    v-icon(dark)
                      | visibility
                  md-tooltip(md-direction="bottom")
                    | {{$t('managementAccess.seeUser')}}
                v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                  v-btn(
                    class="mx-2"
                    x-small
                    fab
                    dark
                    color="#4caf50"
                    @click='handleEditUser(item)'
                  )
                    v-icon(dark)
                      | create
                  md-tooltip(md-direction="bottom")
                    | {{$t('managementAccess.editUser')}}
                v-col(cols='auto' style='padding: 4px; margin: 8px 0;')
                  v-btn(
                    @click='handleDelete(item)'
                    style='margin-right: 3px'
                    class="mx-2"
                    x-small
                    fab
                    dark
                    color="#f44336"
                  )
                    v-icon(dark)
                      | delete
                  md-tooltip(md-direction="bottom")
                    | {{$t('managementAccess.deleteUser')}}
    v-dialog(
      :key="componentKey" v-model='showForm' max-width='80%' @click:outside='closeDialog'
    )
      v-card(style='max-width: 100%;')
        v-toolbar.toolbar-settings.text-settings(style='z-index: 99999')
          span(style='font-size: 1.125rem; line-height: 1.4em; font-weight: 300; font-size: 18px;') {{ formReadOnly ? $t('managementAccess.seeUser') :  editUser ? $t('managementAccess.editUser') :  $t('managementAccess.createUser') }}
          v-spacer
          v-btn#closeIcon(icon color='white' @click='closeDialog')
            md-icon close
        v-card-text(style="padding-top: 30px;").content-dialog
          v-skeleton-loader(
            v-if="loading"
            height="110"
            style='margin: 30px 0;'
            type="card-heading, image"
          )
          div(v-else)
            div(v-if="editPassword")
              div(style="display: flex; flex-direction: column;")
                md-field(:class='mdPass')
                  label {{$t('managementAccess.password')}}
                  md-input(@input='updateSearchItem($event, "password",)' :disabled='formReadOnly' v-model="userData.password" type="password" @keyup.enter="login"  required)
                  span.md-error {{$t('managementAccess.passwordRoles')}}
                md-field(:class='mdPassConfirm')
                  label {{$t('managementAccess.repeat')}}
                  md-input(@input='updateSearchItem($event, "passwordConfirm")' :disabled='formReadOnly' v-model="userData.passwordConfirm" type="password" @keyup.enter="login"  required)
                  span.md-error {{$t('managementAccess.passwordNotMatch')}}
            div(v-else)
              div(style="display: flex; flex-direction: row; justify-content: space-between;")
                v-text-field.mr-2(
                  :rules="[onlyLetters]"
                  :disabled='formReadOnly'
                  :error-messages="errorName && userData.name === '' ? [$t('managementAccess.mandatoryField')] : []"
                  v-model="userData.name"
                  filled
                  density="compact"
                  :placeholder="$t('managementAccess.name')"
                  :value='userData.name'
                  @input='updateSearchItem($event, "name")'
                )
                v-text-field(
                  :rules="[onlyLetters]"
                  :disabled='formReadOnly'
                  :error-messages="errorSurname && userData.surname === '' ? [$t('managementAccess.mandatoryField')] : []"
                  density="compact"
                  v-model="userData.surname"
                  :placeholder="$t('managementAccess.surname')"
                  filled
                  :value='userData.surname'
                  @input='updateSearchItem($event, "surname")'
                )
              div(style="display: flex; flex-direction: row; justify-content: space-between;")
                v-text-field.mr-2(
                  :disabled='formReadOnly'
                  :error-messages="errorUserName && userData.userName === '' ? [$t('managementAccess.mandatoryField')] : []"
                  v-model="userData.userName"
                  filled
                  density="compact"
                  :placeholder="$t('managementAccess.login')"
                  :value='userData.userName'
                  @input='updateSearchItem($event, "login")'
                )
                v-text-field(
                  :disabled='formReadOnly'
                  :error-messages="(userData.email.length >= 1 && !checkEmail(userData.email)) ? [$t('recoveryTeams.invalidEmail')] : (errorEmail && userData.email === '') ? [$t('managementAccess.mandatoryField')] : []"
                  density="compact"
                  v-model="userData.email"
                  :placeholder="$t('managementAccess.email')"
                  filled
                  :value='userData.email'
                  @input='updateSearchItem($event, "email")'
                )
              div
                label(style="font-size: 17px; color: black") {{ $t('managementAccess.password') }}
              div(style="display: flex; flex-direction: row; justify-content: space-between;")
                div(style="width: 50%;")
                  md-field(:class='mdPass')
                    label {{$t('managementAccess.password')}}
                    md-input(@input='updateSearchItem($event, "password",)' :disabled='formReadOnly' v-model="userData.password" type="password" @keyup.enter=""  required)
                    span.md-error {{$t('managementAccess.passwordRoles')}}
                  div(v-if="errorPassword", style="height: 30px;")
                  //- div(v-if="editUser" style="width: max-content; cursor: pointer;" @click='handleUpdatePassword()')
                  //-   label(style="cursor: pointer;" @click='handleUpdatePassword()') {{$t('managementAccess.changePassword')}}
                div(style="width: 48%; margin-left: 2%;")
                  md-field(:class='mdPassConfirm')
                    label {{$t('managementAccess.repeat')}}
                    md-input(@input='updateSearchItem($event, "passwordConfirm")' :disabled='formReadOnly' v-model="userData.passwordConfirm" type="password" @keyup.enter=""  required)
                    span.md-error {{$t('managementAccess.passwordNotMatch')}}
              div(style="margin-top: 20px;")
                label(style="font-size: 17px; color: black") {{ $t('managementAccess.profileSelection') }}
                v-autocomplete(
                  v-model="userData.roles"
                  :items="dataList"
                  :error-messages="errorFunctionalities ? [$t('managementAccess.atLeastOneProfile')] : []"
                  :label='$t("managementAccess.relatedToProfile")'
                  multiple
                  hide-selected
                  :menu-props='formReadOnly ? "" : "openOnClick"'
                  :no-data-text='$t("managementAccess.noMoreProfiles")'
                  :disabled='formReadOnly'
                  @click="selectFunctionality()"
                  )
                  template(v-slot:selection='data')
                    v-hover(v-slot:default="{ hover }")
                      v-chip(:disabled='formReadOnly' style='background-color: #ff9800; border-color: #ff9800; color: black!important; transition: 0.5s' v-bind='data.attrs' :input-value='data' small)
                        | {{ data.item.value }}
                        v-icon(@click='remove(data.item.value)' style='margin-left: 4px;') mdi-close
              div(style="align-items: center; display: flex; flex-direction: row; justify-content: space-between;")
                div(style="display: flex; flex-direction: row; align-items: center;")
                  md-switch(v-model='userData.enabled' :disabled='formReadOnly || loading' @change="updateSearchItem($event, 'enabled')")
                  label {{ !formReadOnly ?  $t("managementAccess.changeUserStatus") : userData.enabled ? $t("managementAccess.enabled") : $t("managementAccess.disabled") }}
                label(v-if='!formReadOnly') {{ userData.enabled ? $t("managementAccess.enabled") : $t("managementAccess.disabled") }}
        v-card-actions(v-if='!formReadOnly').text-right
          v-btn(@click='closeDialog()' color='#A8A8A8' style='color: white; margin-right: 10px') {{ $t('templates.cancel') }}
          v-btn(
            @click='requestPostUser()'
            :disabled="loading"
            color='#43a047'
            style='color: white;') {{ $t('templateEditDialog.save') }}
</template>
<script>
import DataProvider from '@/components/DataProvider'
import moment from 'moment'
import CardNoData from '@/components/CardNoData'
import DataTable from '@/components/DataTable'
import { selectedLocale } from '@/plugins/i18n'
import Swal from 'sweetalert2'

export default {
  data () {
    return {
      loading: false,
      userData: {
        name: '',
        surname: '',
        userName: '',
        email: '',
        password: '',
        passwordConfirm: '',
        roles: [],
        enabled: false
      },
      editPassword: false,
      editUser: false,
      errorPassword: false,
      errorPasswordConfirm: false,
      errorEmail: false,
      errorName: false,
      errorLogin: false,
      errorSurname: false,
      errorUserName: false,
      supportedFileTypes: [],
      fileTypeItems: [],
      errorFunctionalities: false,
      formReadOnly: false,
      showForm: false,
      componentKey: 0,
      dataList: [],
      labels: [this.$t('managementAccess.name'), this.$t('managementAccess.login'), this.$t('managementAccess.rolesAmount'), this.$t('managementAccess.createdAt'), this.$t('managementAccess.createdBy'), this.$t('managementAccess.actions')],
      filter: {
        order: 'desc',
        from: 0,
        size: 5
      }
    }
  },
  async created () {
    await this.requestFunctionalities()
  },
  computed: {
    mdPass () {
      return {
        'md-invalid': this.errorPassword
      }
    },
    mdPassConfirm () {
      return {
        'md-invalid': this.errorPasswordConfirm
      }
    }
  },
  watch: {
    filter: {
      deep: true,
      handler (nV) {
        this.updateList()
      }
    }
  },
  components: {
    DataProvider,
    CardNoData,
    DataTable
  },
  methods: {
    onlyLetters (value) {
      const onlyLettersRegex = /^[A-Za-z\s]+$/
      if (value !== '') {
        return onlyLettersRegex.test(value)
      }
      return false
    },
    checkEmail (email) {
      const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return reg.test(email)
    },
    validPassword (password, pass = true) {
      if (!pass) {
        if (this.userData.password !== password) {
          this.errorPasswordConfirm = true
        } else {
          this.errorPasswordConfirm = false
        }
      } else {
        if (
          this.validateHasNumber(password) &&
          this.validateHasUppercase(password) &&
          this.validateHasNumber(password) &&
          this.validateSpecialCharacters(password) &&
          this.validateHasLowercase(password) &&
          this.validateMinLength(password, 8)
        ) {
          this.errorPassword = false
        } else {
          this.errorPassword = true
        }
      }
    },
    validateHasUppercase (text) {
      const hasUppercaseRegex = /.*[A-Z]+.*/g
      return hasUppercaseRegex.test(text)
    },
    validateHasLowercase (text) {
      const hasLowerRegex = /.*[a-z]+.*/g
      return hasLowerRegex.test(text)
    },
    validateHasNumber (text) {
      const hasNumberRegex = /.*[0-9]+.*/g
      return hasNumberRegex.test(text)
    },
    validateMinLength (text, minLength) {
      return text.length >= minLength
    },
    validateSpecialCharacters (text) {
      const hasSpecialCharacters = /^(?=.*[#?!@$%^&*-])[a-zA-Z0-9#?!@$%^&*-]+$/g
      return hasSpecialCharacters.test(text)
    },
    updateSearchItem (value, key) {
      if (key === 'password' || key === 'passwordConfirm') {
        this.validPassword(value, key === 'password')
      }
      this.userData = { ...this.userData, [key]: value }
    },
    async requestFunctionalities () {
      const { url } = this.mountUrlAndParams('roles')
      try {
        const response = await this.$axios.get(`${url}`)
        if (response && response.status === 200) {
          const list = response.data.hits.map(item => {
            return { text: item._source.name, value: item._source.name, type: [item._source.name] }
          })
          this.dataList = list
          this.supportedFileTypes = list
        }
      } catch (er) {
      }
    },
    validateFields () {
      const { name, surname, email, userName, password, passwordConfirm, roles } = this.userData
      let validatebody = { name, surname, email, userName }

      if (name === '') this.errorName = true
      if (surname === '') this.errorSurname = true
      if (userName === '') this.errorUserName = true
      if (email === '' || (email.length >= 1 && !this.checkEmail(email))) {
        this.errorEmail = true
        validatebody.email = ''
      }
      if ((!this.formReadOnly && !this.editUser && password === '')) {
        this.errorPassword = true
        validatebody.password = ''
      }
      if ((!this.formReadOnly && !this.editUser && password === '')) {
        this.errorPasswordConfirm = true
        validatebody.passwordConfirm = ''
      }
      if (!roles.length) this.errorFunctionalities = true
      validatebody.roles = !roles.length ? null : roles

      const passNotMatch = (password !== passwordConfirm)

      if (password !== '') {
        if (this.errorPassword || this.errorPasswordConfirm || passNotMatch) {
          if (passNotMatch) this.errorPasswordConfirm = true
          validatebody.password = ''
        } else {
          validatebody.password = password
          validatebody.passwordConfirm = passwordConfirm
        }
      }

      const hasEmpty = Object.values(validatebody).some(value => value === '' || value === null || value === undefined)

      return hasEmpty
    },
    handleEditUser (item) {
      this.showForm = true
      this.userData = {
        id: item._id,
        name: item._source.firstName,
        surname: item._source.lastName,
        userName: item._source.login,
        email: item._source.email,
        password: '',
        passwordConfirm: '',
        enabled: (item._source.isActive === 'true' || item._source.isActive === true),
        roles: Array.isArray(item._source.roles) ? item._source.roles : [item._source.roles]
      }
      this.editUser = true
      this.formReadOnly = false
    },
    async requestPostUser () {
      if (!this.validateFields()) {
        if (this.editUser || this.editPassword) {
          this.handleUpdateUser()
        } else {
          const { name, surname, email, userName, password, enabled, roles } = this.userData
          const body = {
            firstName: name,
            lastName: surname,
            email,
            login: userName,
            isActive: enabled,
            pswd: password,
            confirmPswd: password,
            roles: roles.filter(role => role)
          }
          this.loading = true
          const { url } = this.mountUrlAndParams('users')
          this.$axios.post(`${url}`, body).then(response => {
            if (response && response.status === 201) {
              this.loading = false
              this.showForm = false
              Swal.fire({
                title: this.$t(`managementAccess.userCreated`),
                icon: 'success',
                showConfirmButton: false,
                timer: 2500
              })
              setTimeout(() => {
                this.updateList()
              }, 2600)
            }
          }).catch(error => {
            this.resetLocalData()
            this.loading = false
            const message = error?.response?.status === 409
              ? this.$t('recoveryTeams.USER_ALREADY_REGISTERED')
              : this.$t('managementAccess.userErrorCreated')
            Swal.fire({
              icon: 'error',
              title: message,
              showCancelButton: true,
              confirmButtonColor: '#43a047',
              cancelButtonColor: '#A8A8A8',
              cancelButtonText: this.$t('managementAccess.cancel'),
              confirmButtonText: this.$t('managementAccess.createAgain')
            }).then((result) => {
              if (result) {
                this.handleNewUser()
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                this.resetLocalData()
              }
            })
          })
        }
      }
    },
    async handleUpdateUser () {
      const { id, name, surname, email, userName, password, enabled, roles } = this.userData
      let body = {
        firstName: name,
        lastName: surname,
        email,
        login: userName,
        isActive: enabled,
        roles: roles.filter(role => role)
      }

      if (password !== '') {
        body.pswd = password
        body.confirmPswd = password
      }

      try {
        this.loading = true
        const response = await this.$axios.put(`${process.env.VUE_APP_AUTH_BASE_URL}/user/${id}`, body)
        if (response && response.status === 204) {
          this.loading = false
          this.showForm = false
          Swal.fire({
            title: this.editPassword ? this.$t('managementAccess.passwordUpdated') : this.$t('managementAccess.userUpdated'),
            icon: 'success',
            showConfirmButton: false,
            timer: 2500
          })
          setTimeout(() => {
            this.updateList()
          }, 2600)
        }
      } catch (error) {
        this.resetLocalData()
        Swal.fire({
          icon: 'error',
          title: this.editPassword ? this.$t('managementAccess.passwordErrorUpdate') : this.$t('managementAccess.userErrorUpdated'),
          showConfirmButton: false,
          timer: 2500
        })
      }
    },
    handleNewUser () {
      this.showForm = true
      this.userData = {
        name: '',
        surname: '',
        userName: '',
        email: '',
        password: '',
        passwordConfirm: '',
        roles: [],
        enabled: false
      }
      this.formReadOnly = false
    },
    handleShowUser (item) {
      this.userData = {
        name: item._source.firstName,
        surname: item._source.lastName,
        userName: item._source.login,
        password: '',
        passwordConfirm: '',
        email: item._source.email,
        enabled: (item._source.isActive === 'true' || item._source.isActive === true),
        roles: Array.isArray(item._source.roles) ? item._source.roles : [item._source.roles]
      }
      this.formReadOnly = true
      this.showForm = true
    },
    handleDelete (item) {
      Swal.fire({
        icon: 'warning',
        title: this.$t('managementAccess.confirmDeletUser'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$t('commonWords.no'),
        confirmButtonClass: 'md-button md-success btn-fill',
        cancelButtonClass: 'md-button md-danger btn-fill',
        confirmButtonText: this.$t('commonWords.yes'),
        buttonsStyling: false
      }).then(async (result) => {
        if (result.value) {
          try {
            await this.$axios.delete(`${process.env.VUE_APP_AUTH_BASE_URL}/user/${item._id}`)
            Swal.fire({
              title: this.$t('managementAccess.userDeleted'),
              type: 'success',
              icon: 'success',
              showConfirmButton: false,
              timer: 2000
            })
            setTimeout(() => {
              this.updateList()
            }, 2500)
          } catch (error) {
            this.resetLocalData()
            Swal.fire({
              icon: 'error',
              title: this.$t('managementAccess.userDeletedError')
            })
          }
        }
      })
    },
    handleUpdatePassword () {
      this.editPassword = true
    },
    closeDialog () {
      this.resetLocalData()
    },
    remove (itemToRemove) {
      this.userData = {
        ...this.userData,
        roles: this.userData.roles.filter(item => item !== itemToRemove)
      }
    },
    selectFunctionality () {
      this.errorFunctionalities = false
    },
    resetLocalData () {
      this.updateComponentID()
      this.userData = {
        name: '',
        surname: '',
        userName: '',
        email: '',
        password: '',
        passwordConfirm: '',
        roles: [],
        enabled: false
      }
      this.loading = false
      this.errorName = false
      this.errorSurname = false
      this.errorUserName = false
      this.errorEmail = false
      this.errorPassword = false
      this.errorPasswordConfirm = false
      this.errorFunctionalities = false
      this.editPassword = false
      this.editUser = false
      this.showForm = false
      this.formReadOnly = false
    },
    updateList () {
      this.resetLocalData()
      this.$refs.dataProvider.load()
      this.updateComponentID()
    },
    handlePagination (pagination, oldPagination) {
      const newFilter = {}
      const { currentPage, perPage } = pagination
      const nextPage = perPage * (currentPage - 1)
      if (currentPage && this.filter.from !== nextPage) {
        newFilter.from = nextPage
      }
      if (perPage && this.filter.size !== perPage) {
        newFilter.size = perPage
      }
      Object.assign(this.filter, newFilter)
    },
    updateComponentID () {
      this.componentKey += 1
    },
    mountUrlAndParams (endpoint) {
      return {
        url: `${process.env.VUE_APP_AUTH_BASE_URL}/${endpoint}`
      }
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L LT')
    },
    formatLabels (item, i) {
      switch (i) {
        case 0:
          return item._source.firstName
        case 1:
          return item._source.login
        case 2:
          return item._source.countRoles
        case 3:
          return item._source.created ? this.formatDate(item._source.created.at) : '-'
        case 4:
          return item._source.created ? item._source.created.by : '-'
        default:
          break
      }
    },
    createHeaderPDF (doc, total) {
      doc.setFontSize(14)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 10, this.$t('campaign.campaignFiringList'))
      doc.setFontSize(10)
      doc.setFont('times', undefined, '700')
      doc.text(15, 17, this.$t('chatTable.timeCourse'))
      doc.setFont('times', undefined, '300')

      let formattedDate1 = moment(this.filter.from).locale(selectedLocale).format('L LTS')
      let formattedDate2 = moment(this.filter.size).locale(selectedLocale).format('L LTS')
      doc.text(29, 17, `${formattedDate1} até ${formattedDate2}`)

      doc.setFont('times', undefined, '700')
      doc.text(15, 22, this.$t('chatTable.totalConversations'))
      doc.setFont(undefined, undefined, '300')
      doc.text(46, 22, `${total}`)

      const tableOffsetY = 30
      return tableOffsetY
    }
  }
}
</script>
<style lang="scss">
.boxRow {
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
}
#users .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line {
  height: 110px !important;
}
#users .v-skeleton-loader .v-skeleton-loader__list-item-avatar-three-line .v-skeleton-loader__paragraph {
  padding-left: 4px !important;
}
</style>
